import { ArrowRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on home page
  if (location.pathname === "/") return null;

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container mx-auto px-4 mt-2">
      <button
        type="button"
        onClick={handleBack}
        aria-label="رجوع"
        className="inline-flex items-center gap-2 rounded-full bg-primary/10 hover:bg-primary/20 text-primary px-4 py-2 text-sm font-bold transition-colors shadow-sm"
      >
        <ArrowRight className="w-4 h-4" />
        <span>رجوع</span>
      </button>
    </div>
  );
}
